import { FulfillmentGroupCsvColumn } from "@redotech/redo-fulfillment-common/csv-column";
import { FulfillmentGroupData } from "@redotech/redo-fulfillment-group-common/fulfillment-group";

export const DestinationCountryCsvColumn: FulfillmentGroupCsvColumn<FulfillmentGroupData> =
  {
    header: "Country",
    cell: (row) => {
      return row.destinationAddress.countryCode ?? "";
    },
  };
